import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Button, Checkbox, Textarea } from '../../_atoms';
import { LoaderSpinner } from '../loaderAndSpinners';
import { buildGallery } from '../books_in';
import { BooksInAddind } from '../books_in_adding';
import { BooksInExemlarCover } from '../books_in_exemplar_cover';
import { putPicture } from '../../redux/actions/pictures';
import { changeOrderOfPictures, deletePicture } from '../../redux/reducers/picturesReducer';
import backImg from '../../styles/images/icons/back.png';
import { getCalculatedPrice } from '../../redux/actions/products';
import { checkPromocode } from '../../redux/actions/basket';
import { useScrollTop } from '../../helpers/useScrollTop';

const loaderInitial = { loader: 0, showLoader: false, showAnswer: '', showLineLoader: false };

const hideShildaCover = ['photo-book-RU-slim', 'photo-book-RU-soft'];

export const ExtraPhotoBookPremium = ({ max, onBack, addToBasket, id, productId }) => {
  const dispatch = useDispatch();
  const { query = {} } = useLocation();
  useScrollTop();
  const {
    shilda: shildaInitial = '',
    cover = false,
    numberOfCopies: copiesInitial = 1,
    comment: commentInitial = '',
  } = query;

  const { images, coverImages } = useSelector(state => state.pictures.uploadedPictures);

  const [comment, setComment] = useState(commentInitial);
  const [leatherCover, setLeatherCover] = useState(cover);
  const [addShilda, setAddShilda] = useState(!!shildaInitial);
  const [shilda, setShilda] = useState(shildaInitial);
  const [numberOfCopies, setNumberOfCopies] = useState(copiesInitial);

  const [loaderState, setLoaderState] = useState(loaderInitial);
  const [productPrice, setProductPrice] = useState({ price: 0, cover_price: 0, shilda_price: 0, full_price: 0 });

  const [dragItem, setDragItem] = useState(null);
  const [safariScroll, setSafariScroll] = useState(0);

  const showCoverShilda = !hideShildaCover.includes(query.productTypeId || productId);

  const onChangeShildaVisavility = e => {
    setAddShilda(e.target.checked);
    setShilda('');
  };

  const onAddToBasket = () => {
    if (addShilda && !shilda) {
      setLoaderState(l => ({ ...l, showLoader: true, showAnswer: 'Пожалуйста введите текст шильды' }));
      return;
    }
    addToBasket({ comment, numberOfCopies }, { cover: leatherCover, shilda: addShilda ? shilda : '' });
  };

  const addPhoto = async ({ target: { name, files } }) => {
    let { length } = files;
    if (name === 'coverImages' && length + coverImages.length > 4) {
      length = 4 - coverImages.length;
    } else if (name === 'images' && max && length + images.length > max) {
      length = max - images.length;
    }
    const stepLoader = 100 / (length + 1);
    setLoaderState(s => ({ ...s, loader: stepLoader, showLoader: true, showLineLoader: true }));

    for (let i = 0; i < length; i += 1) {
      await dispatch(putPicture(files[i], name));
      setLoaderState(s => ({ ...s, loader: s.loader + stepLoader }));
    }

    if (name === 'images' && max && files.length + images.length > max) {
      setLoaderState({
        ...loaderInitial,
        showLoader: true,
        showAnswer:
          images.length === max
            ? 'Нельзя загрузить больше фотографий.'
            : 'Были загружины не все фотографии из-за привышения лимита.',
      });
    } else {
      setLoaderState(loaderInitial);
    }
  };
  const deletePhoto = (id, massName) => dispatch(deletePicture({ id, massName }));
  const onChangeCopies = e => setNumberOfCopies(e.target.value);

  const saveCurrentPictOrder = item => {
    setDragItem(item);
    setSafariScroll(window.pageYOffset);
  };

  const changePictOrder = dropItem => {
    dispatch(changeOrderOfPictures({ dropItem, dragItem }));
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      window.scrollTo(0, safariScroll);
    }
  };
  const massCoverPhoto = buildGallery({
    mass: coverImages,
    tagName: BooksInExemlarCover,
    count: 1,
    addPhoto,
    deletePhoto,
    saveCurrentPictOrder,
    changePictOrder,
  });

  useEffect(() => {
    Promise.all([
      getCalculatedPrice(query.id || id),
      getCalculatedPrice(query.id || id, true, ''),
      getCalculatedPrice(query.id || id, false, 'shilda text'),
      dispatch(
        checkPromocode({
          accomp_products: [],
          product_variants: [
            {
              leather_cover: false,
              shilda_text: '',
              basket_id: 1679997907831,
              covers: [],
              parent_uid: 'ParentUID16799979078310',
              photos: images.map((img, page) => ({ page: page + 1, id: img.file_id })),
              product_variant_id: query.id || id,
            },
          ],
          shipping_type_id: 'russian_post',
        })
      ),
    ])
      .then(([{ price }, { price: cover_price }, { price: shilda_price }, { products_price }]) => {
        setProductPrice({
          price: products_price,
          cover_price: cover_price - price,
          shilda_price: shilda_price - price,
          full_price: products_price + shilda_price - price + cover_price - price,
        });
      })
      .catch(() => {
        setProductPrice({ price: 0, cover_price: 0, shilda_price: 0, full_price: 0 });
      });
  }, []);

  return (
    <div id="books_in_page" className="books-in-page photobook-premium">
      <img className="go-back" src={backImg} alt="" role="none" onClick={onBack} />
      <p className="books-in-page-title">Добавьте фото, дизайн обложки мы согласуем по email после оформления заказа</p>
      {massCoverPhoto}
      <div className="divider" />
      <div className="photobook-premium__settings">
        <Textarea
          name="comment"
          placeholder="Комментарий к обложке"
          onChange={value => setComment(value)}
          value={comment}
        />
        {showCoverShilda && (
          <>
            <p className="label">Кожаная обложка</p>
            <Checkbox
              className="margin-bottom-24"
              name="leatherCover"
              onChange={e => setLeatherCover(e.target.checked)}
              checked={leatherCover}
            >
              Хочу кожаную обложку за {productPrice.cover_price} руб
            </Checkbox>
            <p className="label">Шильда</p>
            <Checkbox
              className="margin-bottom-24"
              name="addShilda"
              onChange={onChangeShildaVisavility}
              checked={addShilda}
            >
              Хочу металлическую шильду с надписью за {productPrice.shilda_price} руб
            </Checkbox>
            {addShilda && (
              <Textarea name="shild" placeholder="Введите текст шильды" onChange={setShilda} value={shilda} />
            )}
          </>
        )}
        <p className="books-in-page-title">Кол-во экземпляров</p>
        <BooksInAddind numberOfCopies={numberOfCopies} handleChange={onChangeCopies} />
        <div className="dynamic-price">
          Цена:{' '}
          {addShilda && leatherCover
            ? productPrice.full_price * numberOfCopies
            : addShilda
            ? (productPrice.price + productPrice.shilda_price) * numberOfCopies
            : leatherCover
            ? (productPrice.price + productPrice.cover_price) * numberOfCopies
            : productPrice.price * numberOfCopies}
          р.
        </div>
        <Button className="blue" name="currentTab" onClick={onAddToBasket}>
          Добавить в корзину
        </Button>
      </div>

      <LoaderSpinner
        showLoader={loaderState.showLoader}
        showAnswer={loaderState.showAnswer}
        closeLoader={() => setLoaderState(loaderInitial)}
        showLineLoader={loaderState.showLineLoader}
        loader={loaderState.loader}
      />
    </div>
  );
};
